module.exports = __webpack_public_path__ + "img/smao1.05e83841.jpg";